/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

function updateCartAttributesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function updateCartAttributesInput(
    cart: string,
    cartversion: number,
    attributename: string,
    attributevalue: string
): IDataServiceRequest {
    const query = updateCartAttributesQuery();
    return query.createDataServiceRequestForOperation(
        'updateCartAttributes',
        true,
        DataServiceEntities.ChurchUpdateCartAttributerResponseExtensionClass,
        'false',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.IChurchUpdateCartAttributerResponse'
        },
        {
            cart: cart,
            cartversion: cartversion,
            attributename: attributename,
            attributevalue: attributevalue
        }
    );
}

export function updateCartAttributesAsync(
    context: IContext,
    cart: string,
    cartversion: number,
    attributename: string,
    attributevalue: string
): AsyncResult<DataServiceEntities.IChurchUpdateCartAttributerResponse> {
    const request = updateCartAttributesInput(cart, cartversion, attributename, attributevalue);
    return callActionOrExecute<DataServiceEntities.IChurchUpdateCartAttributerResponse>(request, context.callerContext);
}

function updateSubscriptionAddressQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function updateSubscriptionAddressInput(
    _CPBSubscriptionAccountNumber: string,
    _deliveryName: string,
    _street: string,
    _city: string,
    _state: string,
    _zip: string,
    _county: string,
    _country: string,
    _streetNumber: string,
    _districtName: string,
    _buildingCompliment: string
): IDataServiceRequest {
    const query = updateSubscriptionAddressQuery();
    return query.createDataServiceRequestForOperation(
        'updateSubscriptionAddress',
        true,
        DataServiceEntities.CPBupdateSubscriptionAddressResponseExtensionClass,
        'false',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.ICPBupdateSubscriptionAddressResponse'
        },
        {
            _CPBSubscriptionAccountNumber: _CPBSubscriptionAccountNumber,
            _deliveryName: _deliveryName,
            _street: _street,
            _city: _city,
            _state: _state,
            _zip: _zip,
            _county: _county,
            _country: _country,
            _streetNumber: _streetNumber,
            _districtName: _districtName,
            _buildingCompliment: _buildingCompliment
        }
    );
}

export function updateSubscriptionAddressAsync(
    context: IContext,
    _CPBSubscriptionAccountNumber: string,
    _deliveryName: string,
    _street: string,
    _city: string,
    _state: string,
    _zip: string,
    _county: string,
    _country: string,
    _streetNumber: string,
    _districtName: string,
    _buildingCompliment: string
): AsyncResult<DataServiceEntities.ICPBupdateSubscriptionAddressResponse> {
    const request = updateSubscriptionAddressInput(
        _CPBSubscriptionAccountNumber,
        _deliveryName,
        _street,
        _city,
        _state,
        _zip,
        _county,
        _country,
        _streetNumber,
        _districtName,
        _buildingCompliment
    );
    return callActionOrExecute<DataServiceEntities.ICPBupdateSubscriptionAddressResponse>(request, context.callerContext);
}

// @ts-ignore
export function countryLanguageQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('CountryLanguage', 'CountryLanguageEntity', DataServiceEntities.CountryLanguageEntityExtensionClass, key);
}

export function createGetCountryLanguageInput(
    queryResultSettings: IQueryResultSettings,
    retailchannelRecid: number,
    languageId: string
): IDataServiceRequest {
    const query = countryLanguageQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetCountryLanguage',
        true,
        DataServiceEntities.CountryLanguageEntityExtensionClass,
        'true',
        {
            bypassCache: 'none',
            returnEntity: 'DataServiceEntities.ICountryLanguageEntity'
        },
        { retailchannelRecid: retailchannelRecid, languageId: languageId }
    );
}

export function getCountryLanguageAsync(
    context: IContext,
    retailchannelRecid: number,
    languageId: string
): AsyncResult<DataServiceEntities.ICountryLanguageEntity[]> {
    const request = createGetCountryLanguageInput(context.queryResultSettings || {}, retailchannelRecid, languageId);
    return callActionOrExecute<DataServiceEntities.ICountryLanguageEntity[]>(request, context.callerContext);
}

// @ts-ignore
function churchGlobalStoreLocatorInformationQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'ChurchGlobalStoreLocatorInformation',
        'ChurchGlobalStoreLocatorInformation',
        DataServiceEntities.ChurchGlobalStoreLocatorInformationExtensionClass,
        key
    );
}

export function createGetStoreHoursInput(queryResultSettings: IQueryResultSettings, country: string): IDataServiceRequest {
    const query = churchGlobalStoreLocatorInformationQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetStoreHours',
        true,
        DataServiceEntities.ChurchGlobalStoreLocatorInformationExtensionClass,
        'true',
        {
            bypassCache: 'none',
            returnEntity: 'DataServiceEntities.IChurchGlobalStoreLocatorInformation'
        },
        { country: country }
    );
}

export function getStoreHoursAsync(
    context: IContext,
    country: string
): AsyncResult<DataServiceEntities.IChurchGlobalStoreLocatorInformation[]> {
    const request = createGetStoreHoursInput(context.queryResultSettings || {}, country);
    return callActionOrExecute<DataServiceEntities.IChurchGlobalStoreLocatorInformation[]>(request, context.callerContext);
}

// @ts-ignore
export function languageNameQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('LanguageName', 'LanguageNameEntity', DataServiceEntities.LanguageNameEntityExtensionClass, key);
}

export function createGetLanguageNameInput(queryResultSettings: IQueryResultSettings, retailchannelRecId: number): IDataServiceRequest {
    const query = languageNameQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetLanguageName',
        true,
        DataServiceEntities.LanguageNameEntityExtensionClass,
        'true',
        {
            bypassCache: 'none',
            returnEntity: 'DataServiceEntities.ILanguageNameEntity'
        },
        { retailchannelRecId: retailchannelRecId }
    );
}

export function getLanguageNameAsync(
    context: IContext,
    retailchannelRecId: number
): AsyncResult<DataServiceEntities.ILanguageNameEntity[]> {
    const request = createGetLanguageNameInput(context.queryResultSettings || {}, retailchannelRecId);
    return callActionOrExecute<DataServiceEntities.ILanguageNameEntity[]>(request, context.callerContext);
}

// @ts-ignore
export function lDSPolicyQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'LDSPolicy',
        'ChurchRetailChannelPolicyEntity',
        DataServiceEntities.ChurchRetailChannelPolicyEntityExtensionClass,
        key
    );
}

export function createLDSPublisherPolicyInput(policyName: string): IDataServiceRequest {
    const query = churchDataServiceQuery();
    return query.createDataServiceRequestForOperation(
        'LDSPublisherPolicy',
        true,
        DataServiceEntities.ChurchRetailChannelPolicyEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IChurchRetailChannelPolicyEntity' },
        { policyName: policyName }
    );
}

export function lDSPublisherPolicyAsync(
    context: IContext,
    policyName: string
): AsyncResult<DataServiceEntities.IChurchRetailChannelPolicyEntity> {
    const request = createLDSPublisherPolicyInput(policyName);
    return callActionOrExecute<DataServiceEntities.IChurchRetailChannelPolicyEntity>(request, context.callerContext);
}

export function createGetChannelPoliciesInput(queryResultSettings: IQueryResultSettings, channelRecId: number): IDataServiceRequest {
    const query = churchDataServiceQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetChannelPolicies',
        true,
        DataServiceEntities.ChurchChannelPoliciesEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IChurchChannelPoliciesEntity' },
        { channelRecId: channelRecId }
    );
}

export function getChannelPoliciesAsync(
    context: IContext,
    channelRecId: number
): AsyncResult<DataServiceEntities.IChurchChannelPoliciesEntity[]> {
    const request = createGetChannelPoliciesInput(context.queryResultSettings || {}, channelRecId);
    return callActionOrExecute<DataServiceEntities.IChurchChannelPoliciesEntity[]>(request, context.callerContext);
}

// @ts-ignore
export function channelCountryQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'ChannelCountry',
        'ChurchRetailChannelCountryEntity',
        DataServiceEntities.ChurchRetailChannelCountryEntityExtensionClass,
        key
    );
}

export function createChurchRetailChannelCountryAsyncInput(
    queryResultSettings: IQueryResultSettings,
    channelid: number
): IDataServiceRequest {
    const query = channelCountryQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'ChurchRetailChannelCountryAsync',
        true,
        DataServiceEntities.ChurchRetailChannelCountryEntityExtensionClass,
        'true',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.IChurchRetailChannelCountryEntity'
        },
        { channelid: channelid }
    );
}

export function churchRetailChannelCountryAsyncAsync(
    context: IContext,
    channelid: number
): AsyncResult<DataServiceEntities.IChurchRetailChannelCountryEntity[]> {
    const request = createChurchRetailChannelCountryAsyncInput(context.queryResultSettings || {}, channelid);
    return callActionOrExecute<DataServiceEntities.IChurchRetailChannelCountryEntity[]>(request, context.callerContext);
}

// @ts-ignore
function smartyStreetQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'SmartyStreet',
        'ChurchSmartyStreetAddressEntity',
        DataServiceEntities.ChurchSmartyStreetAddressEntityExtensionClass,
        key
    );
}

export function createvalidateSuggestAddressInput(
    street: string,
    city: string,
    state: string,
    zipcode: string,
    country: string,
    district: string,
    street2?: string
): IDataServiceRequest {
    const query = smartyStreetQuery();
    return query.createDataServiceRequestForOperation(
        'validateSuggestAddress',
        true,
        DataServiceEntities.ChurchSmartyStreetResponseExtensionClass,
        'false',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.IChurchSmartyStreetResponse'
        },
        {
            //SmartyStreet api request
            // street: street2 ? `${street} ${street2}` : street,
            street: street,
            street2: street2,
            city: city,
            state: state,
            zipcode: zipcode,
            country: country,
            district: district
        }
    );
}

export function validateSuggestAddressAsync(
    context: IContext,
    street: string,
    city: string,
    state: string,
    zipcode: string,
    country: string,
    district: string,
    street2?: string
): AsyncResult<DataServiceEntities.IChurchSmartyStreetResponse> {
    const request = createvalidateSuggestAddressInput(street, city, state, zipcode, country, district, street2);
    return callActionOrExecute<DataServiceEntities.IChurchSmartyStreetResponse>(request, context.callerContext);
}

// @ts-ignore
function renewSubscriptionsQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'RenewSubscriptions',
        'ChurchSubscriptionPDPEntity',
        DataServiceEntities.ChurchSubscriptionPDPEntityExtensionClass,
        key
    );
}

export function createGetChurchPDPsInput(
    queryResultSettings: IQueryResultSettings,
    itemid: string,
    itemcolorid: string,
    itemsizeid: string,
    itemStyleId: string,
    cart: Entities.Cart,
    quantity: number,
    subscriptionId: string
): IDataServiceRequest {
    const query = renewSubscriptionsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetChurchPDPs',
        true,
        DataServiceEntities.ChurchSubscriptionPDPEntityExtensionClass,
        'true',
        {
            bypassCache: 'none',
            returnEntity: 'DataServiceEntities.IChurchSubscriptionPDPEntity'
        },
        {
            itemid: itemid,
            itemcolorid: itemcolorid,
            itemsizeid: itemsizeid,
            itemStyleId: itemStyleId,
            cart: cart,
            quantity: quantity,
            subscriptionId: subscriptionId
        }
    );
}

export function getChurchPDPsAsync(
    context: IContext,
    itemid: string,
    itemcolorid: string,
    itemsizeid: string,
    itemStyleId: string,
    cart: Entities.Cart,
    quantity: number,
    subscriptionId: string
): AsyncResult<DataServiceEntities.IChurchSubscriptionPDPEntity[]> {
    const request = createGetChurchPDPsInput(
        context.queryResultSettings || {},
        itemid,
        itemcolorid,
        itemsizeid,
        itemStyleId,
        cart,
        quantity,
        subscriptionId
    );
    return callActionOrExecute<DataServiceEntities.IChurchSubscriptionPDPEntity[]>(request, context.callerContext);
}

// @ts-ignore
function churchDataServiceQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'ChurchDataService',
        'ChurchTableSelectEntity',
        DataServiceEntities.ChurchTableSelectEntityExtensionClass,
        key
    );
}

export function createSelectFromInput(
    queryResultSettings: IQueryResultSettings,
    tableSchema: string,
    tableName: string,
    whereClause: string
): IDataServiceRequest {
    const query = churchDataServiceQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'SelectFrom',
        true,
        DataServiceEntities.ChurchTableSelectEntityExtensionClass,
        'true',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.IChurchTableSelectEntity'
        },
        { tableSchema: tableSchema, tableName: tableName, whereClause: whereClause }
    );
}

export function selectFromAsync(
    context: IContext,
    tableSchema: string,
    tableName: string,
    whereClause: string
): AsyncResult<DataServiceEntities.IChurchTableSelectEntity[]> {
    const request = createSelectFromInput(context.queryResultSettings || {}, tableSchema, tableName, whereClause);
    return callActionOrExecute<DataServiceEntities.IChurchTableSelectEntity[]>(request, context.callerContext);
}

// @ts-ignore
function identificationTypesQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('IdentificationTypes', 'TaxRegistrationType', DataServiceEntities.TaxRegistrationTypeExtensionClass, key);
}

export function createGetIdentificationTypesInput(queryResultSettings: IQueryResultSettings, country: string): IDataServiceRequest {
    const query = identificationTypesQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetIdentificationTypes',
        true,
        DataServiceEntities.TaxRegistrationTypeExtensionClass,
        'true',
        {
            bypassCache: 'none',
            returnEntity: 'DataServiceEntities.ITaxRegistrationType'
        },
        { country: country }
    );
}

export function getIdentificationTypesAsync(context: IContext, country: string): AsyncResult<DataServiceEntities.ITaxRegistrationType[]> {
    const request = createGetIdentificationTypesInput(context.queryResultSettings || {}, country);
    return callActionOrExecute<DataServiceEntities.ITaxRegistrationType[]>(request, context.callerContext);
}

// @ts-ignore
function identificationTypesApplicabilityRuleQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'IdentificationTypesApplicabilityRule',
        'TaxRegistrationTypeApplicabilityRule',
        DataServiceEntities.TaxRegistrationTypeApplicabilityRuleExtensionClass,
        key
    );
}

export function createGetIdentificationTypesApplicabilityRulesInput(
    queryResultSettings: IQueryResultSettings,
    country: string,
    taxIdentificationtype: string,
    identificationNumber: string
): IDataServiceRequest {
    const query = identificationTypesApplicabilityRuleQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetIdentificationTypesApplicabilityRules',
        true,
        DataServiceEntities.TaxRegistrationTypeApplicabilityRuleExtensionClass,
        'true',
        {
            bypassCache: 'none',
            returnEntity: 'DataServiceEntities.ITaxRegistrationTypeApplicabilityRule'
        },
        {
            country: country,
            taxIdentificationtype: taxIdentificationtype,
            identificationNumber: identificationNumber
        }
    );
}

export function getIdentificationTypesApplicabilityRulesAsync(
    context: IContext,
    country: string,
    taxIdentificationtype: string,
    identificationNumber: string
): AsyncResult<DataServiceEntities.ITaxRegistrationTypeApplicabilityRule[]> {
    const request = createGetIdentificationTypesApplicabilityRulesInput(
        context.queryResultSettings || {},
        country,
        taxIdentificationtype,
        identificationNumber
    );
    return callActionOrExecute<DataServiceEntities.ITaxRegistrationTypeApplicabilityRule[]>(request, context.callerContext);
}

// @ts-ignore
export function churchUnitBillingQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'ChurchUnitBilling',
        'ChurchUnitBillingEntity',
        DataServiceEntities.ChurchUnitBillingEntityExtensionClass,
        key
    );
}

export function createGetUnitBillingInput(
    queryResultSettings: IQueryResultSettings,
    accountNum: string,
    retailchannelRecid: number,
    cart: Entities.Cart
): IDataServiceRequest {
    const query = churchUnitBillingQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetUnitBilling',
        true,
        DataServiceEntities.ChurchUnitBillingEntityExtensionClass,
        'true',
        {
            bypassCache: 'none',
            returnEntity: 'DataServiceEntities.IChurchUnitBillingEntity'
        },
        {
            accountNum: accountNum,
            retailchannelRecid: retailchannelRecid,
            cart: cart
        }
    );
}

export function getUnitBillingAsync(
    context: IContext,
    accountNum: string,
    retailchannelRecid: number,
    cart: Entities.Cart
): AsyncResult<DataServiceEntities.IChurchUnitBillingEntity[]> {
    const request = createGetUnitBillingInput(context.queryResultSettings || {}, accountNum, retailchannelRecid, cart);
    return callActionOrExecute<DataServiceEntities.IChurchUnitBillingEntity[]>(request, context.callerContext);
}

// @ts-ignore
export function subscriptionsQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'Subscriptions',
        'CPBCustomerSubscriptionsEntity',
        DataServiceEntities.CPBCustomerSubscriptionsEntityExtensionClass,
        key
    );
}

export function createGetCustomerSubscriptionsInput(
    queryResultSettings: IQueryResultSettings,
    _customerAccount: string,
    _language: string
): IDataServiceRequest {
    const query = subscriptionsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetCustomerSubscriptions',
        true,
        DataServiceEntities.CPBCustomerSubscriptionsEntityExtensionClass,
        'true',
        {
            bypassCache: 'none',
            returnEntity: 'DataServiceEntities.ICPBCustomerSubscriptionsEntity'
        },
        { _customerAccount: _customerAccount, _language: _language }
    );
}

export function getCustomerSubscriptionsAsync(
    context: IContext,
    _customerAccount: string,
    _language: string
): AsyncResult<DataServiceEntities.ICPBCustomerSubscriptionsEntity[]> {
    const request = createGetCustomerSubscriptionsInput(context.queryResultSettings || {}, _customerAccount, _language);
    return callActionOrExecute<DataServiceEntities.ICPBCustomerSubscriptionsEntity[]>(request, context.callerContext);
}

// @ts-ignore
function churchUnitOrderShipmentHistoryQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'ChurchUnitOrderShipmentHistory',
        'ChurchOrderShipmentEntity',
        DataServiceEntities.ChurchOrderShipmentEntityExtensionClass,
        key
    );
}

export function createGetOrderShipmentsHistoryInput(
    queryResultSettings: IQueryResultSettings,
    customerAccountNumber: string,
    startDateTime: Date,
    top: number,
    skip: number
): IDataServiceRequest {
    const query = churchUnitOrderShipmentHistoryQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetOrderShipmentsHistory',
        true,
        DataServiceEntities.ChurchOrderShipmentEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IChurchOrderShipmentEntity' },
        { customerAccountNumber: customerAccountNumber, startDateTime: startDateTime, top: top, skip: skip }
    );
}

export function getOrderShipmentsHistoryAsync(
    context: IContext,
    customerAccountNumber: string,
    startDateTime: Date,
    top: number,
    skip: number
): AsyncResult<DataServiceEntities.IChurchOrderShipmentEntity[]> {
    const request = createGetOrderShipmentsHistoryInput(context.queryResultSettings || {}, customerAccountNumber, startDateTime, top, skip);
    return callActionOrExecute<DataServiceEntities.IChurchOrderShipmentEntity[]>(request, context.callerContext);
}

// @ts-ignore
function churchServicesQuery(id?: string): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'ChurchServices',
        'ChurchServiceResultEntity',
        DataServiceEntities.ChurchServiceResultEntityExtensionClass,
        key
    );
}

export function createChurchValidatePaymentInput(cartid: string, cartversion: number, tendertype: number): IDataServiceRequest {
    const query = churchServicesQuery();
    return query.createDataServiceRequestForOperation(
        'ChurchValidatePayment',
        true,
        DataServiceEntities.ChurchServiceResultEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IChurchServiceResultEntity' },
        { cartid: cartid, cartversion: cartversion, tendertype: tendertype }
    );
}

export function churchValidatePaymentAsync(
    context: IContext,
    cartid: string,
    cartversion: number,
    tendertype: number
): AsyncResult<DataServiceEntities.IChurchServiceResultEntity> {
    const request = createChurchValidatePaymentInput(cartid, cartversion, tendertype);
    return callActionOrExecute<DataServiceEntities.IChurchServiceResultEntity>(request, context.callerContext);
}

export function createGetProductSizeChartInput(productRecId: number, languageId: string): IDataServiceRequest {
    const query = churchDataServiceQuery();
    return query.createDataServiceRequestForOperation(
        'GetProductSizeChart',
        true,
        DataServiceEntities.ChurchSizeChartEntityExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IChurchSizeChartEntity' },
        { productRecId: productRecId, languageId: languageId }
    );
}

export function getProductSizeChartAsync(
    context: IContext,
    productRecId: number,
    languageId: string
): AsyncResult<DataServiceEntities.IChurchSizeChartEntity> {
    const request = createGetProductSizeChartInput(productRecId, languageId);
    return callActionOrExecute<DataServiceEntities.IChurchSizeChartEntity>(request, context.callerContext);
}

export function createGetRetailChannelInput(channelRecId: number): IDataServiceRequest {
    const query = churchDataServiceQuery();
    return query.createDataServiceRequestForOperation(
        'GetRetailChannel',
        true,
        DataServiceEntities.ChurchRetailChannelEntityExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IChurchRetailChannelEntity' },
        { channelRecId: channelRecId }
    );
}

export function getRetailChannelAsync(
    context: IContext,
    channelRecId: number
): AsyncResult<DataServiceEntities.IChurchRetailChannelEntity> {
    const request = createGetRetailChannelInput(channelRecId);
    return callActionOrExecute<DataServiceEntities.IChurchRetailChannelEntity>(request, context.callerContext);
}

export function createGetCitiesInput(
    queryResultSettings: IQueryResultSettings,
    countryRegionId: string,
    stateProvinceId: string,
    countyId: string
): IDataServiceRequest {
    const query = churchDataServiceQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetCities',
        true,
        EntityClasses.CityInfoClass,
        'true',
        { bypassCache: 'none', returnEntity: 'Entities.CityInfo' },
        { countryRegionId: countryRegionId, stateProvinceId: stateProvinceId, countyId: countyId }
    );
}

export function getCitiesAsync(
    context: IContext,
    countryRegionId: string,
    stateProvinceId: string,
    countyId: string
): AsyncResult<Entities.CityInfo[]> {
    const request = createGetCitiesInput(context.queryResultSettings || {}, countryRegionId, stateProvinceId, countyId);
    return callActionOrExecute<Entities.CityInfo[]>(request, context.callerContext);
}

export function createGetCountiesInput(
    queryResultSettings: IQueryResultSettings,
    countryRegionId: string,
    stateProvinceId: string
): IDataServiceRequest {
    const query = churchDataServiceQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetCounties',
        true,
        EntityClasses.CountyInfoClass,
        'true',
        { bypassCache: 'none', returnEntity: 'Entities.CountyInfo' },
        { countryRegionId: countryRegionId, stateProvinceId: stateProvinceId }
    );
}

export function getCountiesAsync(context: IContext, countryRegionId: string, stateProvinceId: string): AsyncResult<Entities.CountyInfo[]> {
    const request = createGetCountiesInput(context.queryResultSettings || {}, countryRegionId, stateProvinceId);
    return callActionOrExecute<Entities.CountyInfo[]>(request, context.callerContext);
}

export function createGetWarehouseInput(warehouseId: string): IDataServiceRequest {
    const query = churchDataServiceQuery();
    return query.createDataServiceRequestForOperation(
        'GetWarehouse',
        true,
        DataServiceEntities.ChurchInventLocationEntityExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IChurchInventLocationEntity' },
        { warehouseId: warehouseId }
    );
}

export function getWarehouseAsync(context: IContext, warehouseId: string): AsyncResult<DataServiceEntities.IChurchInventLocationEntity> {
    const request = createGetWarehouseInput(warehouseId);
    return callActionOrExecute<DataServiceEntities.IChurchInventLocationEntity>(request, context.callerContext);
}

export function createGetUnitAddressesInput(
    queryResultSettings: IQueryResultSettings,
    membershipUnit: boolean,
    city: string,
    state: string
): IDataServiceRequest {
    const query = churchDataServiceQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetUnitAddresses',
        true,
        DataServiceEntities.ChurchUnitPostalAddressesEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IChurchUnitPostalAddressesEntity' },
        { membershipUnit: membershipUnit, city: city, state: state }
    );
}

export function getUnitAddressesAsync(
    context: IContext,
    membershipUnit: boolean,
    city: string,
    state: string
): AsyncResult<DataServiceEntities.IChurchUnitPostalAddressesEntity[]> {
    const request = createGetUnitAddressesInput(context.queryResultSettings || {}, membershipUnit, city, state);
    return callActionOrExecute<DataServiceEntities.IChurchUnitPostalAddressesEntity[]>(request, context.callerContext);
}

export function createGetZipcodesInput(
    queryResultSettings: IQueryResultSettings,
    countryRegionId: string,
    stateProvinceId: string,
    countyId: string,
    cityId: string
): IDataServiceRequest {
    const query = churchDataServiceQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetZipcodes',
        true,
        EntityClasses.ZipCodeInfoClass,
        'true',
        { bypassCache: 'none', returnEntity: 'Entities.ZipCodeInfo' },
        { countryRegionId: countryRegionId, stateProvinceId: stateProvinceId, countyId: countyId, cityId: cityId }
    );
}

export function getZipcodesAsync(
    context: IContext,
    countryRegionId: string,
    stateProvinceId: string,
    countyId: string,
    cityId: string
): AsyncResult<Entities.ZipCodeInfo[]> {
    const request = createGetZipcodesInput(context.queryResultSettings || {}, countryRegionId, stateProvinceId, countyId, cityId);
    return callActionOrExecute<Entities.ZipCodeInfo[]>(request, context.callerContext);
}

export function createGetDistrictsInput(
    queryResultSettings: IQueryResultSettings,
    countryRegionId: string,
    stateProvinceId: string,
    countyId: string,
    city: string
): IDataServiceRequest {
    const query = churchDataServiceQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetDistricts',
        true,
        EntityClasses.DistrictInfoClass,
        'true',
        { bypassCache: 'none', returnEntity: 'Entities.DistrictInfo' },
        { countryRegionId: countryRegionId, stateProvinceId: stateProvinceId, countyId: countyId, city: city }
    );
}

export function getDistrictsAsync(
    context: IContext,
    countryRegionId: string,
    stateProvinceId: string,
    countyId: string,
    city: string
): AsyncResult<Entities.DistrictInfo[]> {
    const request = createGetDistrictsInput(context.queryResultSettings || {}, countryRegionId, stateProvinceId, countyId, city);
    return callActionOrExecute<Entities.DistrictInfo[]>(request, context.callerContext);
}

export function createValidateAddressFormatInput(addressRecId: number): IDataServiceRequest {
    const query = churchDataServiceQuery();
    return query.createDataServiceRequestForOperation(
        'ValidateAddressFormat',
        true,
        DataServiceEntities.ChurchValidateAddressFormatEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IChurchValidateAddressFormatEntity' },
        { addressRecId: addressRecId }
    );
}

export function validateAddressFormatAsync(
    context: IContext,
    addressRecId: number
): AsyncResult<DataServiceEntities.IChurchValidateAddressFormatEntity> {
    const request = createValidateAddressFormatInput(addressRecId);
    return callActionOrExecute<DataServiceEntities.IChurchValidateAddressFormatEntity>(request, context.callerContext);
}
